<template>
    <div class="pg-search">
        <header>
            <div class="search-wrapper clear">
                <input type="text" v-model="keyword" @keypress.enter="search" placeholder="请输入产品名称/CAS/牌号/生产商">
                <span class="after" v-show="keyword" @click="clearInput">x</span>
            </div>
            <button type="button" @click='search'>搜索</button>
        </header>
        <h3>
            最近搜索
            <span class="search-history-delete" @click="deleteHistory"></span>
        </h3>
        <div class="recent-search">
            <a href="javascript:;" v-for="(item, idx) in keywords" :key="idx" v-if="idx <= 9"
                @click.prevent="search(item)">{{ item }}</a>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                keyword: "",
                keywords: []
            }
        },
        metaInfo: {
            title: 'AI Selection for Materials - from Ibuychem.com,Leading Manufacturers & Suppliers of Chemical Materials and Products in China',
            meta: [
                { name: "keywords", content: "chemical raw material, chemical properties,properties,chemical brand,coatings, inks, plastic,adhesive,PE,PP,PVC,resin,pigments, additives,TDS,MSDS,SDS" },
                { name: "description", content: "Provide performance tables for over 200000 types of chemical raw materials, and continuously improve and add new ones. You can directly search and browse online or print and read the product performance table you have found. The current  performance table parameters include injection molding parameters, plastic melt index, hardness, flow index, plastic raw material usage, etc; The chemical performance table parameters include: content, dosage PH、 Formulas, alternative products, etc.。" }
            ],
        },
        mounted() {
            _hmt.push(['_trackPageview', `/${window.location.hash}`]);
            let keywords = localStorage.getItem('keywords');

            if (keywords) {
                this.keywords = keywords.split(',') || [];
            }
            if (this.keywords.length > 5) {
                let temkw = this.keywords.slice(0, 5);
                this.keywords = [];
                this.keywords.push.apply(this.keywords, temkw)
            }
        },
        methods: {
            clearInput() {
                this.keyword = ""
            },
            search(x) {
                //   Message({
                //       message:'搜索不到您想要的结果！',
                //       showClose:true,
                //       customClass:'search-msg-style',
                //       duration:0

                //   });
                if (typeof x === 'string') {
                    this.keyword = x;
                }
                let kw = this.keyword;

                if (this.keywords.indexOf(kw) < 0) {
                    this.keywords.unshift(kw)
                }
                let kws = this.keywords.join(',')
                if (kw !== '') {
                    localStorage.setItem('keywords', kws)
                }
                this.$router.push({ path: 'prolist', query: { fr: 0, kw: encodeURIComponent(encodeURIComponent(kw)) } })
            },
            deleteHistory() {
                this.keywords = [];
                localStorage.removeItem('keywords');
            }
        },
        components: {

        }
    }
</script>

<style lang="less">

    .pg-search {
        .search-msg-style {
            top: 50%;
            background-color: #fff;
            border-radius: 10px;
            width: 80%;
            min-width: 80px;
        }

        background-color: #f5f5f5;
        height: 100%;

        header {
            display: flex;
            margin-bottom: 1rem;

            .search-wrapper {
                flex: 1;
                display: flex;
                padding-top: .5rem;
                padding-left: 1rem;

                input {
                    flex: 1;
                    height: 3rem;
                    border-radius: 4rem;
                    outline: none;
                    border: none;
                    padding-left: 3rem;
                    background: #fff url(../../assets/images/search-icon.png) 1rem no-repeat;
                    background-size: 1.6rem;
                }
            }

            .clear {
                position: relative;

                .after {
                    content: "x";
                    position: absolute;
                    width: 1.2rem;
                    height: 1.2rem;
                    background-color: #f5f5f5;
                    border-radius: 4rem;
                    right: .5rem;
                    top: 1.5rem;
                    line-height: 1rem;
                    text-align: center;
                    color: #999;
                }
            }

            button {
                flex: none;
                width: 4rem;
                height: 4rem;
                font-size: 1.6rem;
                color: #0994ff;
                outline: none;
                border: none;
                background-color: #f5f5f5;
            }
        }

        h3 {
            font-size: 1.4rem;
            padding-left: 1rem;
            color: #333;
            position: relative;

            .search-history-delete {
                position: absolute;
                top: 0;
                right: 1rem;
                width: 1.6rem;
                height: 1.6rem;
                background: url('../../assets/images/icon-delete.png') no-repeat;
                background-size: contain;
            }
        }

        .recent-search {
            padding: 1rem;

            a {
                line-height: 2.4rem;
                display: block;
                float: left;
                padding: 0 1rem;
                border-radius: 2rem;
                background-color: #e5e5e5;
                margin-right: 1rem;
                margin-bottom: 1rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/search.vue